import { RouteConfig } from 'vue-router'
import VueI18n from 'vue-i18n'
const TaskCategoriesView: DynamicImport = () => import(/* webpackChunkName: "tasks" */ '../views/TaskCategoriesView.vue')

const routes: (i18n: VueI18n) => Array<RouteConfig> = (i18n) => ([
  {
    name: 'tasks-categories',
    path: 'tasks-categories',
    component: TaskCategoriesView,
    meta: {
      title: i18n.t('tasks.categories.pageTitle'),
      appModule: 'task',
      userPermission: ['app-configuration', 1]
    }
  }
])

export default routes
